export default "__VITE_ASSET__CDrRrykg__"